import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../projects/accounting/src//public_api';

@Component({
  selector: 'app-ice-cream',
  templateUrl: './ice-cream.component.html',
  styleUrls: ['./ice-cream.component.scss']
})
export class IceCreamComponent implements OnInit {

  constructor(
    private api: ApiService
  ) { }

  ngOnInit() {
  }
  async load(){

  }
}
